import { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import styles from "../../styles/home.module.css";

/**
 * Quality showcase section. Pass an optional `src` (mp4 url) to play a real
 * video on click; without it the section renders as a decorative banner.
 */
const VideoSection = ({ src }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    if (!src || !videoRef.current) return;
    setPlaying(true);
    videoRef.current.play();
  };

  return (
    <section className={styles.section}>
      <div className={styles.video} onClick={handlePlay}>
        {src && (
          <video
            ref={videoRef}
            src={src}
            playsInline
            controls={playing}
            onEnded={() => setPlaying(false)}
          />
        )}

        {!playing && (
          <>
            <div className={styles.videoOverlay} />
            <div className={styles.playBtn}>
              <FaPlay style={{ marginRight: "4px" }} />
            </div>
            <span className={styles.videoTitle}>شاهد الجودة على الطبيعة</span>
          </>
        )}
      </div>
    </section>
  );
};

export default VideoSection;
